// src/components/Footer.jsx or Footer.js
import React from "react";
import "./Footer.css";

const Footer = () => {
  return (
    <footer className="cn-footer" role="contentinfo">
      <span className="cn-footer-text">Powered by</span>
      <a
        href="https://cntechnologies.co.zw/"
        target="_blank"
        rel="noopener noreferrer"
        className="cn-glow-btn"
        aria-label="Visit CN Technologies website"
        title="CN Technologies"
      >
        <span className="cn-glow-core">
          <span className="cn-label" aria-hidden="true">CN</span>
          <span className="cn-glow-layer cn-glow-1" aria-hidden="true" />
          <span className="cn-glow-layer cn-glow-2" aria-hidden="true" />
          <span className="cn-glow-layer cn-glow-3" aria-hidden="true" />
          <span className="cn-sparkles" aria-hidden="true">
            <span className="cn-sparkle s1" />
            <span className="cn-sparkle s2" />
            <span className="cn-sparkle s3" />
            <span className="cn-sparkle s4" />
            <span className="cn-sparkle s5" />
            <span className="cn-sparkle s6" />
          </span>
        </span>
      </a>
    </footer>
  );
};

export default Footer;
